import * as React from 'react';

export interface IContactProps {
}

export function Contact(props: IContactProps) {
    const handleSubmit = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        // Handle form submission logic here
    };
    return (
        <section className="contact-section">
            <div className="contact-container">
                <h2 className="contact-title">Get In Touch With Me</h2>
                <div className="contact-content">
                    <div className="contact-info">
                        <h3>Contact Information</h3>
                        <div className="contact-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <div>
                                <strong>Address</strong>
                                <p>Storgatan 64, 17152 Solna<br />Stockholm, Sweden</p>
                            </div>
                        </div>
                        <div className="contact-item">
                            <i className="fas fa-phone"></i>
                            <div>
                                <strong>Phone</strong>
                                <p>+46 767 025 106 | +91 8943014949</p>
                            </div>
                        </div>
                        <div className="contact-item">
                            <i className="fas fa-envelope"></i>
                            <div>
                                <strong>Email</strong>
                                <p><a href="mailto:vishnumohandas11@gmail.com">vishnumohandas11@gmail.com</a></p>
                            </div>
                        </div>
                        
                        <div className="contact-social">
                            <h4>Follow Me</h4>
                            <div className="social-links">
                                <a href="https://www.linkedin.com/in/vishnu-das-78b009281/" target="_blank" rel="noreferrer" className="social-link">
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                                <a href="https://www.twitter.com" target="_blank" rel="noreferrer" className="social-link">
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a href="https://www.facebook.com/Vishnu.mohandas.k" target="_blank" rel="noreferrer" className="social-link">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                                <a href="https://www.instagram.com/vishnu.mohandas.k/" target="_blank" rel="noreferrer" className="social-link">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    <div className="contact-form-wrapper">
                        <h3>Send Message</h3>
                        <form className="contact-form" action="/" method="post">
                            <div className="form-row">
                                <div className="form-group">
                                    <input type="text" name="name" placeholder="Your Name" required className="form-input" />
                                </div>
                                <div className="form-group">
                                    <input type="email" name="email" placeholder="Your Email" required className="form-input" />
                                </div>
                            </div>
                            <div className="form-group">
                                <input type="text" name="subject" placeholder="Subject" required className="form-input" />
                            </div>
                            <div className="form-group">
                                <textarea name="message" rows={6} placeholder="Your Message" required className="form-input"></textarea>
                            </div>
                            <button onClick={handleSubmit} className="submit-button">Send Message</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}
